// function for setting cell color based on percentage //
import React from "react"
import tinycolor from 'tinycolor2'

const QbAts = ({ val, percision }) => {

    // func for imperceisely handling float-point rounding hell //
    function truncate (num, places) {
        return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
    }

    var parsedVal = parseFloat(val)

    const c6n = '#c4d8ff'
    const c4n = '#d1d2ff'
    const c2n = '#e2dbff'
    const c0 = '#ffffff'
    const c2p = '#ffdbf8'
    const c4p = '#ffe1cf'
    const c6p = '#fffbd9'

    // background //
    var calcedBackground = '#ffffff'
    if (parsedVal <= -6) {
        calcedBackground = c6n
    } else if (parsedVal <= -4) {
        calcedBackground = tinycolor.mix(c6n, c4n, 100 * (parsedVal + 6) / 2 )
    } else if (parsedVal <= -2) {
        calcedBackground = tinycolor.mix(c4n, c2n, 100 * (parsedVal + 4) / 2)
    }  else if (parsedVal <= 0) {
        calcedBackground = tinycolor.mix(c2n, c0, 100 * (parsedVal + 2) / 2)
    } else if (parsedVal <= 2) {
        calcedBackground = tinycolor.mix(c0, c2p, 100 * (parsedVal - 0) / 2)
    } else if (parsedVal <= 4) {
        calcedBackground = tinycolor.mix(c2p, c4p, 100 * (parsedVal - 2) / 2)
    } else {
        calcedBackground = tinycolor.mix(c4p, c6p, 100 * (parsedVal - 4) / 2)
    }

    return (
        <div style={{
            background : calcedBackground,
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {truncate(parsedVal, percision)}
        </div>
    )
    
}

export default QbAts